<div class="sales-selection">
    <form [formGroup]="searchUserForm">
        <mat-grid-list cols="1" [rowHeight]="'30px'" [gutterSize]="'5px'" class="form-grid">

            <mat-grid-tile class="labels">Customer Name</mat-grid-tile>
            <mat-grid-tile class="select" id="type-select-tile">
                <mat-form-field appearance="outline">
                    <mat-select multiple placeholder="All" [matTooltipClass]="'my-tooltip'"
                        matTooltip="{{ selectedValues.master_customer_name }}" formControlName="userCustomer" #Customer
                        (selectionChange)="
                        changeFilter($event.value, 'master_customer_name')"
                        (openedChange)="onFilterMultiOpened($event, 'master_customer_name')">
                        <mat-select-trigger>
                            {{ multiSelectTriggerLabel('master_customer_name') }}
                        </mat-select-trigger>
                        <mat-option *ngIf="formDetails.master_customer_name?.length > 10">
                            <ngx-mat-select-search [formControl]="searchCustomer" placeholderLabel="Find Customer..."
                                noEntriesFoundLabel="'no matching ECC found'"></ngx-mat-select-search></mat-option>
                        <div class="icon">
                            <mat-icon (click)="Customer.close()">arrow_drop_up</mat-icon>
                        </div>
                        <mat-option #allCustomerSelected (onSelectionChange)="onAllOptionSelectionChange($event, 'master_customer_name')"
                            value="All">All</mat-option>
                        <mat-option *ngFor="let item of filteredCustomer | async" [value]="item.value"
                            >
                            {{ item.viewValue }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </mat-grid-tile>


            <mat-grid-tile class="labels">Engine Model</mat-grid-tile>
            <mat-grid-tile class="select" id="type-select-tile">
                <mat-form-field appearance="outline">
                    <mat-select multiple placeholder="All" formControlName="userEngine" #engine
                        [matTooltipClass]="'my-tooltip'" matTooltip="{{ selectedValues.engine_model }}"
                        (selectionChange)="changeFilter($event.value, 'engine_model')"
                        (openedChange)="onFilterMultiOpened($event, 'engine_model')">
                        <mat-select-trigger>
                            {{ multiSelectTriggerLabel('engine_model') }}
                        </mat-select-trigger>
                        <mat-option *ngIf="formDetails.engine_model?.length > 10">
                            <ngx-mat-select-search [formControl]="searchEngine" placeholderLabel="Find Engine Model..."
                                noEntriesFoundLabel="'no matching ECC found'"></ngx-mat-select-search></mat-option>
                        <div class="icon">
                            <mat-icon (click)="engine.close()">arrow_drop_up</mat-icon>
                        </div>
                        <mat-option #allEngineSelected (onSelectionChange)="onAllOptionSelectionChange($event, 'engine_model')" value="All">All</mat-option>
                        <mat-option *ngFor="let item of filteredEngine | async" [value]="item.value"
                            >
                            {{ item.viewValue }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </mat-grid-tile>

            <mat-grid-tile class="labels">Displacement</mat-grid-tile>
            <mat-grid-tile class="select" id="type-select-tile">
                <mat-form-field appearance="outline">
                    <mat-select multiple placeholder="All" formControlName="userDisplacement" #Displacement
                        [matTooltipClass]="'my-tooltip'" matTooltip="{{ selectedValues.displacement }}"
                        (selectionChange)="changeFilter($event.value, 'displacement')"
                        (openedChange)="onFilterMultiOpened($event, 'displacement')">
                        <mat-select-trigger>
                            {{ multiSelectTriggerLabel('displacement') }}
                        </mat-select-trigger>
                        <mat-option *ngIf="formDetails.displacement?.length > 10">
                            <ngx-mat-select-search [formControl]="searchDis" placeholderLabel="Find Dis..."
                                noEntriesFoundLabel="'no matching ECC found'"></ngx-mat-select-search></mat-option>
                        <div class="icon">
                            <mat-icon (click)="Displacement.close()">arrow_drop_up</mat-icon>
                        </div>
                        <mat-option #allDisSelected (onSelectionChange)="onAllOptionSelectionChange($event, 'displacement')" value="All">All</mat-option>
                        <mat-option *ngFor="let item of filteredDis | async" [value]="item.value"
                            >
                            {{ item.viewValue }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </mat-grid-tile>

            <mat-grid-tile class="labels">Certification</mat-grid-tile>
            <mat-grid-tile class="select" id="type-select-tile">
                <mat-form-field appearance="outline">
                    <mat-select multiple placeholder="All" formControlName="userCertification" #Certification
                        [matTooltipClass]="'my-tooltip'" matTooltip="{{ selectedValues.certification }}"
                        (selectionChange)="changeFilter($event.value, 'certification')"
                        (openedChange)="onFilterMultiOpened($event, 'certification')">
                        <mat-select-trigger>
                            {{ multiSelectTriggerLabel('certification') }}
                        </mat-select-trigger>
                        <mat-option *ngIf="formDetails.certification?.length > 10">
                            <ngx-mat-select-search [formControl]="searchCert" placeholderLabel="Find Cert..."
                                noEntriesFoundLabel="'no matching ECC found'"></ngx-mat-select-search>
                        </mat-option>
                        <div class="icon">
                            <mat-icon (click)="Certification.close()">arrow_drop_up</mat-icon>
                        </div>
                        <mat-option #allCertificationSelected (onSelectionChange)="onAllOptionSelectionChange($event, 'certification')"
                            value="All">All</mat-option>
                        <mat-option *ngFor="let item of filteredCert | async" [value]="item.value"
                            >
                            {{ item.viewValue }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </mat-grid-tile>


            <mat-grid-tile class="labels">ECC</mat-grid-tile>
            <mat-grid-tile class="select" id="type-select-tile">
                <mat-form-field appearance="outline">
                    <mat-select multiple placeholder="All" formControlName="userEcc" [matTooltipClass]="'my-tooltip'"
                        matTooltip="{{ selectedValues.ecc }}" #ecc
                        (selectionChange)="changeFilter($event.value, 'ecc')"
                        (openedChange)="onFilterMultiOpened($event, 'ecc')">
                        <mat-select-trigger>
                            {{ multiSelectTriggerLabel('ecc') }}
                        </mat-select-trigger>
                        <mat-option *ngIf="formDetails.ecc?.length > 10">
                            <ngx-mat-select-search [formControl]="searchEcc" placeholderLabel="Find ECC..."
                                noEntriesFoundLabel="'no matching ECC found'"></ngx-mat-select-search>
                        </mat-option>
                        <div class="icon">
                            <mat-icon (click)="ecc.close()">arrow_drop_up</mat-icon>
                        </div>
                        <mat-option #allEccSelected (onSelectionChange)="onAllOptionSelectionChange($event, 'ecc')" value="All">All</mat-option>
                        <mat-option *ngFor="let item of filteredEcc | async" [value]="item.value"
                            >
                            {{ item.viewValue }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </mat-grid-tile>

            <mat-grid-tile class="labels">LOB - L2</mat-grid-tile>
            <mat-grid-tile class="select" id="type-select-tile">
                <mat-form-field appearance="outline">
                    <mat-select multiple placeholder="All" [matTooltipClass]="'my-tooltip'"
                        matTooltip="{{ selectedValues.lob_l2 }}" formControlName="userLob" #lob
                        (selectionChange)="changeFilter($event.value, 'lob_l2')"
                        (openedChange)="onFilterMultiOpened($event, 'lob_l2')">
                        <mat-select-trigger>
                            {{ multiSelectTriggerLabel('lob_l2') }}
                        </mat-select-trigger>
                        <mat-option *ngIf="formDetails.lob_l2?.length > 10">
                            <ngx-mat-select-search [formControl]="searchLob" placeholderLabel="Find Customer..."
                                noEntriesFoundLabel="'no matching ECC found'"></ngx-mat-select-search></mat-option>
                        <div class="icon">
                            <mat-icon (click)="lob.close()">arrow_drop_up</mat-icon>
                        </div>
                        <mat-option #allLobSelected (onSelectionChange)="onAllOptionSelectionChange($event, 'lob_l2')" value="All">All</mat-option>
                        <mat-option *ngFor="let item of filteredLob | async" [value]="item.value"
                            >
                            {{ item.viewValue }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </mat-grid-tile>



            <mat-grid-tile class="labels">Product Bu</mat-grid-tile>
            <mat-grid-tile class="select" id="type-select-tile">
                <mat-form-field appearance="outline">
                    <mat-select multiple placeholder="All" [matTooltipClass]="'my-tooltip'"
                        matTooltip="{{ selectedValues.current_product_bu }}" formControlName="userProductBu" #ProductBu
                        (selectionChange)="changeFilter($event.value, 'current_product_bu')"
                        (openedChange)="onFilterMultiOpened($event, 'current_product_bu')">
                        <mat-select-trigger>
                            {{ multiSelectTriggerLabel('current_product_bu') }}
                        </mat-select-trigger>
                        <mat-option *ngIf="formDetails.current_product_bu?.length > 10">
                            <ngx-mat-select-search [formControl]="searchProductBu" placeholderLabel="Find Product..."
                                noEntriesFoundLabel="'no matching ECC found'"></ngx-mat-select-search></mat-option>
                        <div class="icon">
                            <mat-icon (click)="ProductBu.close()">arrow_drop_up</mat-icon>
                        </div>
                        <mat-option #allProductBuSelected (onSelectionChange)="onAllOptionSelectionChange($event, 'current_product_bu')" value="All">All</mat-option>
                        <mat-option *ngFor="let item of filteredProductBu | async" [value]="item.value"
                            >
                            {{ item.viewValue }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </mat-grid-tile>


        </mat-grid-list>
    </form>
</div>